import React from 'react';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import Box from 'reusecore/src/elements/Box';
import Text from 'reusecore/src/elements/Text';
import Heading from 'reusecore/src/elements/Heading';
import Button from 'reusecore/src/elements/Button';
import Card from 'reusecore/src/elements/Card';
import Image from 'reusecore/src/elements/Image';
import Container from 'common/src/components/UI/Container';

import Wrapper from './style';
import ImageOne from 'common/src/assets/image/saasModern/dash-1.png';
import ImageTwo from 'common/src/assets/image/saasModern/dash-2.png';
import {
  GActions,
  GLabels,
  sendEvent
} from 'common/src/hooks/googleEvents';

const InfoSection = ({
  row,
  col,
  title,
  description,
  button,
  buttonWrapper,
  fillButton,
  textArea,
  imageArea,
  imageAreaRow,
  imageWrapper,
  imageWrapperOne,
  imageWrapperTwo,
  textAreaRow,
}) => {
  return (
    <Wrapper>
      <Container fullWidth noGutter className="info-sec-container">
        <Box {...row} {...imageAreaRow}>
          <Box {...col} {...imageArea} className="image_area">
            <Card {...imageWrapper} {...imageWrapperOne}>
              <Fade left>
                <Image src={ImageOne} alt="Info Image One" />
              </Fade>
            </Card>
            <Card {...imageWrapper} {...imageWrapperTwo}>
              <Fade bottom>
                <Image src={ImageTwo} alt="Info Image Two" />
              </Fade>
            </Card>
          </Box>
        </Box>
      </Container>
      <Container>
        <Box {...row} {...textAreaRow}>
          <Box {...col} {...textArea}>
            <Heading as="h2" content="CHAT & MESSAGING" style={{ "fontSize": "14px", "fontWeight": "700", "lineHeight": "24px", "marginBottom": "12px", "letterSpacing": "1.5px", "color": "#2aa275" }} />
            <Heading
              {...title}
              content="Next-Gen chat solution built for hyper gaming scale"
            />
            <Text
              {...description}
              content="Connect, engage, retain and monetize millions of in-game users in just 15 seconds!"
            />
            <Fade up delay={300}>
              <Box {...buttonWrapper}>
                <a onClick={sendEvent({ url: 'https://console.fizz.io', action: GActions.StartFree, label: GLabels.JoinTrail })} href="https://console.fizz.io">
                  <Button style={{ fontWeight: '700' }}
                    {...fillButton}
                    title="START FREE"
                  />
                </a>
                <a onClick={sendEvent({ url: 'http://bit.ly/fizzreqaccess', action: GActions.ContactSales, label: GLabels.JoinTrail })} href="http://bit.ly/fizzreqaccess">
                  <Button style={{ fontWeight: '700' }} {...fillButton} title="CONTACT SALES" />
                </a>
              </Box>
            </Fade>
          </Box>
        </Box>
      </Container>
    </Wrapper>
  );
};

InfoSection.propTypes = {
  row: PropTypes.object,
  col: PropTypes.object,
  title: PropTypes.object,
  description: PropTypes.object,
  button: PropTypes.object,
  textArea: PropTypes.object,
  imageArea: PropTypes.object,
  imageAreaRow: PropTypes.object,
  imageWrapper: PropTypes.object,
  imageWrapperOne: PropTypes.object,
  imageWrapperTwo: PropTypes.object,
  textAreaRow: PropTypes.object,
};

InfoSection.defaultProps = {
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: '-15px',
    mr: '-15px',
  },
  textAreaRow: {
    flexDirection: 'row-reverse',
  },
  col: {
    pr: '15px',
    pl: '15px',
  },
  textArea: {
    width: ['100%', '100%', '50%', '50%', '42%'],
  },
  imageArea: {
    width: ['100%', '100%', '50%', '50%', '55%'],
    flexBox: true,
  },
  imageWrapper: {
    boxShadow: 'none',
  },
  imageWrapperOne: {
    mr: ['-250px', '-250px', '-200px', '-250px', '-400px'],
  },
  imageWrapperTwo: {
    alignSelf: 'flex-end',
    mb: '-60px',
  },
  title: {
    fontSize: ['26px', '32px', '36px', '40px', '48px'],
    fontWeight: '400',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: '20px',
    lineHeight: '1.25',
  },
  description: {
    fontSize: ['15px', '15px', '15px', '16px', '16px'],
    color: '#343d48cc',
    lineHeight: '2',
    mb: '33px',
  },
  button: {
    type: 'button',
    fontSize: '14px',
    fontWeight: '600',
    borderRadius: '4px',
    pl: '22px',
    pr: '22px',
    colors: 'secondaryWithBg',
  },
  buttonWrapper: {
    flexBox: true,
    justifyContent: 'space-evenly',
    mt: '35px',
  },
  fillButton: {
    type: 'button',
    fontSize: ['13px', '14px'],
    fontWeight: '800',
    borderRadius: '4px',
    p: ['0px 15px', '8px 22px'],
    colors: 'secondaryWithBg',
    minWidth: ['auto', '150px'],
    height: ['40px', '46px'],
    minHeight: 'auto',
  },
};

export default InfoSection;
